import { createClient } from '@supabase/supabase-js';

// This core module provides a factory that works across Web and RN.
// On web, pass no storage to use default; on RN, pass a storage adapter.

export type SupabaseClientOptions = {
    url: string;
    anonKey: string;
    storage?: {
        getItem: (key: string) => Promise<string | null> | string | null;
        setItem: (key: string, value: string) => Promise<void> | void;
        removeItem: (key: string) => Promise<void> | void;
    };
    detectSessionInUrl?: boolean;
};

export function createSupabaseForUniversal({ url, anonKey, storage, detectSessionInUrl = true }: SupabaseClientOptions) {
    return createClient(url, anonKey, {
        auth: {
            flowType: 'pkce',
            autoRefreshToken: true,
            detectSessionInUrl,
            storage: storage as any,
        },
    });
}
